export const COPIED_SUCCESS_DURATION = 1500;
export const COPIED_TEXT = 'Copied!';
export const COPY_TEXT = 'Copy';
